export default {
      id: "viroflay_alu-usage",
      viewBox: "0 0 540 85",
      url: "../dist/images/" + "sprite.svg#viroflay_alu-usage",
      toString: function () {
        return this.url;
      }
    }